// WebSocket connection that reconnects and resumes the same player.
export function connect(onMsg) {
  let ws, playerId = sessionStorageGet('door.playerId'), resumeToken = sessionStorageGet('door.resumeToken');
  let name = sessionStorageGet('door.name') || '';
  const browserId = browserIdOf(globalThis.localStorage);
  const queue = [];

  function open() {
    ws = new WebSocket(`${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}`);
    ws.onopen = () => {
      ws.send(JSON.stringify({ t: 'hello', name, playerId, resumeToken, browserId }));
      while (queue.length) ws.send(queue.shift());
    };
    ws.onmessage = e => {
      const msg = JSON.parse(e.data);
      if (msg.t === 'welcome') {
        playerId = msg.playerId; resumeToken = msg.resumeToken;
        sessionStorageSet('door.playerId', playerId); sessionStorageSet('door.resumeToken', resumeToken);
      }
      onMsg(msg);
    };
    ws.onclose = () => { onMsg({ t: 'offline' }); setTimeout(open, 1500); };
  }
  open();

  return {
    send(msg) {
      if (msg.t === 'hello') { name = msg.name; sessionStorageSet('door.name', name); }
      const data = JSON.stringify(msg);
      if (ws.readyState === 1) ws.send(data); else queue.push(data);
    },
  };
}

// One id per browser (localStorage): two tabs of one person look alike to the night shift matcher.
export function browserIdOf(storage, make = () => crypto.randomUUID()) {
  try {
    let id = storage.getItem('door.browserId');
    if (!id) { id = make(); storage.setItem('door.browserId', id); }
    return id;
  } catch { return null; }
}

function sessionStorageGet(k) { try { return sessionStorage.getItem(k); } catch { return null; } }
function sessionStorageSet(k, v) { try { sessionStorage.setItem(k, v); } catch { /* private mode */ } }
